import { getApiFactory } from '../../../api/api-injector';
import { InputResetQuoteFromIssuePending, ResultVoid } from '../../../api/dealer-api-interface-all';

/**
 * Support operations for resetting quotes from issue pending states.
 * Provides Cyncly Staff functionality for recovering quotes stuck in transitional states.
 */
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class QuoteResetSupport {
  public static async resetQuoteFromIssuePending(quoteId: string): Promise<ResultVoid | null> {
    const input: InputResetQuoteFromIssuePending = { quoteId };
    return await getApiFactory().clientAgent().resetQuoteFromIssuePending(input);
  }
}
